<template>
  <m-g2>
    <template #pr-1 class="justify-content-center align-items-center">
      <slot name="pr-1" />
    </template>

    <template #pl-1>
      <m-h4 class="h4">
        <m-strong>
          <slot name="th4" />
        </m-strong>
      </m-h4>

      <m-p class="text-muted my-5">
        <m-strong>
          <slot name="tp" />
        </m-strong>
      </m-p>

      <slot name="ta" />
    </template>


  </m-g2>
</template>

<script>
export default {
  name: "S10",
};
</script>

<style scoped>
</style>